import { use, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Loader from "../../../../../shared_components/Loader";
import AlreadyCompletedQuiz from "../../../../QuizStudio/component/common/AlreadyCompletedQuiz";

import { getQuizTestDetails } from "../../../../QuizStudio/actions";
import AssessmentDetails from "./AssessmentDetails";
// import AssessmentModeCard from "./AssessmentModeCard";
import TopicsCoveredCard from "./TopicsCoveredCard";
import LearningObjectiveCard from "./LearningObjectiveCard";
import Prerequisites from "./Prerequisites";
// import UserDetailsCard from "./UserDetailsCard";
import IndustryCertificates from "./IndustryCertificates";
// import PricingOptions from "./PricingOptions";
import StartQuiz from "./StartQuiz";
import "./style.scss";
import assessmentMetaData from "./AssessmentMetaData";
import { resolveAssessmentMetaData } from "../../../../../utils/assessmentMetaUtils";

const WelcomeTestInstruction = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  // const quizdata = assessmentMetaData.find((quiz) => quiz.quizId === id);

  const { currentQuizTest, quizTestDataLoading } =
    useSelector((state) => state.quizTest) || {};
  
  const quizTest = currentQuizTest?.quizTest;
  const [hasCompleted, setHasCompleted] = useState(false);
  const [showAlreadyCompleted, setShowAlreadyCompleted] = useState(false);

  const testUser = JSON.parse(localStorage.getItem("userDetails"));

  // useEffect(() => {
  //   dispatch(getQuizTestDetails({ quizTest: id })).then((res) => {
  //     setHasCompleted(res?.data?.hasCompleted);
  //   });
  // }, [dispatch, id]);

  useEffect(() => {
    const loadQuiz = async () => {
      const res = await dispatch(getQuizTestDetails({ quizTest: id }));
      const completed = res?.data?.hasCompleted;
      setHasCompleted(completed);

      if(completed==false){
        setShowAlreadyCompleted(false);
        return
      }

      const quiz = res?.data.quizTest;

      const canStart=
        quiz?.access === "public" && 
        Boolean(quiz?.quizId) &&
        Array.isArray(quiz?.quizQuestions);

        setShowAlreadyCompleted(!canStart);
    } ;

    loadQuiz();
  }, [dispatch, id]);

  const quizdata = resolveAssessmentMetaData({
  metaData: assessmentMetaData,
  quizTechnology: currentQuizTest?.quizTechnology,
  quizTitle: currentQuizTest?.quizTitle
});


  return (
    <>
      {quizTestDataLoading ? (
        <Loader />
      ) : showAlreadyCompleted ? (
        <div>
          <AlreadyCompletedQuiz testType={"assessment"} />
        </div>
      ) : (
        <div className="mx-md-5 px-md-5 mx-2 py-5">
          <div className="text-primary text-center fs-3 fw-bold mb-3">
            Welcome, {testUser.firstName} {testUser.lastName}
          </div>
          <AssessmentDetails
            currentQuizTest={currentQuizTest}
            level={quizdata?.level}
            description={quizdata?.description}
            stats={quizdata?.stats}
          />
          <div className="row mx-0">
            <div className="col-md-8">
              {/* <AssessmentModeCard /> */}
              <LearningObjectiveCard objectives={quizdata?.learningObjectives}/>
              <TopicsCoveredCard topicscover={quizdata?.topicsCovered}/>
              <Prerequisites prerequisites={quizdata?.prerequisites}/>
            </div>
            <div className="col-md-4">
              <StartQuiz id={id} />
              <IndustryCertificates />
              {/* <PricingOptions /> */}
              {/* <UserDetailsCard /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WelcomeTestInstruction;
